import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/images/logo_update.svg';
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "card mb-25 border-0 rounded-0 bg-white letter-spacing invoice-details-box"
};
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_4 = {
    key: 0,
    class: "d-lg-flex justify-content-between"
};
const _hoisted_5 = { class: "text-start" };
const _hoisted_6 = {
    key: 0,
    class: "mb-5 text-muted fs-md-15 fs-md-16 lh-base"
};
const _hoisted_7 = {
    key: 1,
    class: "d-block text-muted fs-md-15 fs-md-16"
};
const _hoisted_8 = { class: "text-lg-center mt-15 mt-md-20 mt-lg-0" };
const _hoisted_9 = { class: "d-block fs-md-15 fs-md-16 text-muted" };
const _hoisted_10 = { class: "me-md-5 d-block d-md-inline-block" };
const _hoisted_11 = { class: "text-paragraph" };
const _hoisted_12 = { class: "ms-md-5 d-block d-md-inline-block" };
const _hoisted_13 = { class: "text-paragraph" };
const _hoisted_14 = {
    key: 0,
    class: "text-lg-end mt-15 mt-md-20 mt-lg-0"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "invoice-info d-lg-flex justify-content-between" };
const _hoisted_17 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_18 = { class: "d-block fs-md-15 fs-lg-16 fw-medium text-paragraph mb-8" };
const _hoisted_19 = { class: "mb-5 text-muted fs-md-15 fs-md-16 lh-base" };
const _hoisted_20 = { class: "ms-10 ms-sm-50 ms-md-100" };
const _hoisted_21 = {
    key: 0,
    class: "d-block fs-md-15 fs-lg-16 fw-medium text-paragraph mb-8"
};
const _hoisted_22 = {
    key: 1,
    class: "table-responsive"
};
const _hoisted_23 = {
    key: 2,
    class: "order-summary-list ps-0 mb-0 list-unstyled"
};
const _hoisted_24 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_25 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_26 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" };
const _hoisted_27 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_28 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_29 = { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" };
const _hoisted_30 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_31 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_32 = {
    key: 1,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_33 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_34 = { class: "d-block text-primary fs-md-15 fs-lg-16 fw-bold" };
const _hoisted_35 = {
    class: "modal fade",
    id: "contentModalScrollable_facture",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_36 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_37 = {
    key: 0,
    class: "modal-content"
};
const _hoisted_38 = {
    key: 0,
    class: "modal-header"
};
const _hoisted_39 = { class: "modal-title fs-5" };
const _hoisted_40 = { class: "modal-body align-items-center justify-content-center" };
const _hoisted_41 = { class: "flex-column items-center justify-content-center" };
const _hoisted_42 = { class: "ticket-system" };
const _hoisted_43 = { class: "receipts-wrapper" };
const _hoisted_44 = {
    class: "receipts",
    id: "recu-pdf"
};
const _hoisted_45 = {
    key: 0,
    class: "receipt"
};
const _hoisted_46 = {
    key: 0,
    class: "route"
};
const _hoisted_47 = {
    key: 1,
    class: "route"
};
const _hoisted_48 = {
    key: 2,
    class: "route"
};
const _hoisted_49 = {
    key: 3,
    class: "product-ticket"
};
const _hoisted_50 = { style: { "font-weight": "600", "font-size": "12px", "margin-bottom": "8px" } };
const _hoisted_51 = { style: { "display": "flex", "justify-content": "space-between", "font-size": "11px" } };
const _hoisted_52 = {
    key: 0,
    style: { "margin": "2px 0 0 10px", "font-size": "9px", "color": "#555" }
};
const _hoisted_53 = {
    key: 4,
    class: "product-list"
};
const _hoisted_54 = { style: { "display": "flex", "justify-content": "space-between", "margin": "5px 0" } };
const _hoisted_55 = { style: { "display": "flex", "justify-content": "space-between", "margin": "5px 0" } };
const _hoisted_56 = { style: { "display": "flex", "justify-content": "space-between", "margin": "5px 0" } };
const _hoisted_57 = { style: { "display": "flex", "justify-content": "space-between", "margin": "5px 0" } };
const _hoisted_58 = { style: { "display": "flex", "justify-content": "space-between", "margin": "5px 0" } };
const _hoisted_59 = { key: 0 };
const _hoisted_60 = {
    key: 5,
    class: "route"
};
const _hoisted_61 = { key: 0 };
const _hoisted_62 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoaderComponent)
        ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.transformedData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _cache[2] || (_cache[2] = _createElementVNode("img", {
                                src: _imports_0,
                                class: "black-logo",
                                alt: "logo",
                                style: { "width": "140px", "height": "auto" }
                            }, null, -1)),
                            _cache[3] || (_cache[3] = _createElementVNode("img", {
                                src: _imports_0,
                                class: "white-logo",
                                alt: "logo",
                                style: { "width": "140px", "height": "auto" }
                            }, null, -1)),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-block mt-12 mt-md-15 mt-lg-30 fs-md-15 fs-lg-16 fw-medium text-paragraph mb-5 mb-md-8" }, " Restaurant ", -1)),
                            (_ctx.transformedData.restaurantId)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                                    _createTextVNode(_toDisplayString(_ctx.transformedData.restaurant.name ?? '') + " ", 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.transformedData.restaurant.codePostal ?? '') + " " + _toDisplayString(_ctx.transformedData.restaurant.numeroRue ?? '') + _toDisplayString(_ctx.transformedData.restaurant.address ?? ''), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.transformedData.restaurantId)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Tel : " + _toDisplayString(_ctx.transformedData.restaurant.phoneNumber ?? ''), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-black fw-black mb-5 mb-sm-10 mb-lg-20 fs-18 fs-md-20 fs-lg-30" }, " Référence ", -1)),
                            _createElementVNode("span", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, [
                                    _cache[5] || (_cache[5] = _createTextVNode(" ref.commande : ", -1)),
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.transformedData.paymentReference), 1)
                                ]),
                                _createElementVNode("span", _hoisted_12, [
                                    _cache[6] || (_cache[6] = _createTextVNode(" Date : ", -1)),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.convertDateCreate(_ctx.transformedData.created_at)), 1)
                                ])
                            ])
                        ]),
                        (_ctx.qrcode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("img", {
                                    src: _ctx.qrcode,
                                    alt: "qr-code"
                                }, null, 8, _hoisted_15)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                    (_ctx.transformedData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "d-block text-black fs-md-15 fw-bold mb-12" }, " Opération effectuée par: ", -1)),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.transformedData.clientName), 1),
                                _createElementVNode("p", _hoisted_19, " Tel : " + _toDisplayString(_ctx.transformedData.clientPhone), 1)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "d-block text-black fs-md-15 fw-bold mb-12" }, " Paiement: ", -1)),
                                (_ctx.transformedData && _ctx.transformedData.paymentMethod)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.getMethodePaiementParType(_ctx.transformedData.paymentMethod)), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "buttons-list mt-15 mt-md-20 mt-lg-0" }, null, -1))
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "d-block text-black fs-md-15 fw-bold mb-15 mb-md-20 mb-lg-25" }, " Récapitulatif de commande ", -1)),
                (_ctx.transformedData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[11] || (_cache[11] = [
                            _createStaticVNode("<table class=\"table text-nowrap align-middle mb-0\" data-v-333d6abb><thead data-v-333d6abb><tr data-v-333d6abb><th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0\" data-v-333d6abb> #Num </th><th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0\" data-v-333d6abb> Produit </th><th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0\" data-v-333d6abb> Quantité </th><th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0\" data-v-333d6abb> Prix unitaire </th><th scope=\"col\" class=\"text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0\" data-v-333d6abb> Prix total </th></tr></thead></table>", 1)
                        ]))]))
                    : _createCommentVNode("", true),
                (_ctx.transformedData)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
                        (_ctx.transformedData)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('order.subtotal')), 1),
                                _createElementVNode("span", _hoisted_26, _toDisplayString((_ctx.transformedData.amount - (_ctx.transformedData.amount * 2.60 / 100)).toFixed(2)) + " CHF ", 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("li", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('order.vat')), 1),
                            _createElementVNode("span", _hoisted_29, _toDisplayString((_ctx.transformedData.amount * 2.60 / 100).toFixed(2)) + " CHF ", 1)
                        ]),
                        _createElementVNode("li", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('order.discount')), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "d-block text-black fs-md-15 fs-lg-16 fw-medium" }, " 0 CHF ", -1))
                        ]),
                        (_ctx.transformedData && _ctx.transformedData.amount)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('order.totalGross')), 1),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.transformedData.amount) + " CHF ", 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "d-block text-black text-center fs-md-15 fs-lg-16 mt-15 mt-md-25 mt-lg-35 mt-xl-50" }, [
                    _createTextVNode(" # Merci de toujours nous faire confiance "),
                    _createElementVNode("span", { class: "text-primary fw-bold" }, "VaBene Pizzeria"),
                    _createTextVNode(" # ")
                ], -1))
            ]),
            _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                    (_ctx.transformedData)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_ctx.transformedData.orderSelf)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("h1", _hoisted_39, "Facture de la commande #" + _toDisplayString(_ctx.getShortUuid(_ctx.transformedData.orderSelf.id)), 1),
                                    _cache[15] || (_cache[15] = _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    }, null, -1))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("main", _hoisted_42, [
                                        _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                                (_ctx.transformedData.orderSelf)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                        _cache[21] || (_cache[21] = _createElementVNode("img", {
                                                            src: _imports_0,
                                                            class: "airliner-logo"
                                                        }, null, -1)),
                                                        (_ctx.transformedData.orderSelf.restaurantID)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, "Livraison de pizzas " + _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.name), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.raison_sociale || _ctx.transformedData.orderSelf.restaurantID.name), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.address), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.codePostalID?.numeroPostal || '') + " " + _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.name), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, "+4121 " + _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.phoneNumber), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.restaurantID.taxe), 1)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "dashed-line" }, null, -1)),
                                                        (_ctx.transformedData.orderSelf)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.guest_first_name) + " " + _toDisplayString(_ctx.transformedData.orderSelf.guest_last_name), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.address) + " - " + _toDisplayString(_ctx.transformedData.orderSelf.numberRue), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.npa ?? '') + " " + _toDisplayString(_ctx.transformedData.orderSelf.localite ?? ''), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.guest_phone_number), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.guest_email), 1)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "dashed-line" }, null, -1)),
                                                        (_ctx.transformedData.orderSelf)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.orderTypeSelected[0]?.libelle || ''), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.convertDateCreate(_ctx.transformedData.orderSelf.created_at)), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.DeliveryPreference != 'immediat' ? _ctx.$t('order.preOrder') : _ctx.$t('order.immediately')), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.convertDateCreate(_ctx.transformedData.orderSelf.timeOrder) ?? ''), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString((_ctx.transformedData.orderSelf.restaurantID.name.toLowerCase().includes('morges') ? 'VBM' : 'VBP') + _ctx.transformedData.orderSelf.nif), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.getLast6Digits(_ctx.transformedData.orderSelf.customer.id)), 1)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "dashed-line" }, null, -1)),
                                                        (_ctx.transformedData.orderSelf)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedByCategory, (items, categoryName) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                        key: categoryName,
                                                                        class: "category-section",
                                                                        style: { "margin-bottom": "10px" }
                                                                    }, [
                                                                        _createElementVNode("div", _hoisted_50, _toDisplayString(categoryName), 1),
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                                                                            return (_openBlock(), _createElementBlock("div", {
                                                                                key: item?.id || 'unknown-item',
                                                                                style: { "display": "flex", "flex-direction": "column", "margin-bottom": "10px" }
                                                                            }, [
                                                                                _createElementVNode("div", _hoisted_51, [
                                                                                    _createElementVNode("span", null, [
                                                                                        _createElementVNode("strong", null, _toDisplayString(item.quantity) + "x " + _toDisplayString(item.productID.name), 1)
                                                                                    ]),
                                                                                    _cache[16] || (_cache[16] = _createElementVNode("span", null, [
                                                                                        _createElementVNode("strong", null, "0 CHF")
                                                                                    ], -1))
                                                                                ]),
                                                                                (item.ingredients && item.ingredients.length)
                                                                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_52, [
                                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ingredients, (ingredient) => {
                                                                                            return (_openBlock(), _createElementBlock("li", {
                                                                                                key: ingredient.id,
                                                                                                class: "text-decoration-none list-unstyled"
                                                                                            }, [
                                                                                                _createElementVNode("strong", null, "x" + _toDisplayString(ingredient.quantite) + " " + _toDisplayString(ingredient.name) + " (" + _toDisplayString(ingredient.size) + ")", 1)
                                                                                            ]));
                                                                                        }), 128))
                                                                                    ]))
                                                                                    : _createCommentVNode("", true)
                                                                            ]));
                                                                        }), 128))
                                                                    ]));
                                                                }), 128))
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "dashed-line" }, null, -1)),
                                                        (_ctx.transformedData.orderSelf)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                _createElementVNode("div", _hoisted_54, [
                                                                    _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('order.subtotal')) + ": ", 1)
                                                                    ]),
                                                                    _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, _toDisplayString((_ctx.transformedData.orderSelf.total_price - (_ctx.transformedData.orderSelf.total_price * 2.60 / 100)).toFixed(2)) + " CHF", 1)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_55, [
                                                                    _cache[17] || (_cache[17] = _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, "2.60% TVA ")
                                                                    ], -1)),
                                                                    _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, _toDisplayString((_ctx.transformedData.orderSelf.total_price * 2.60 / 100).toFixed(2)) + " CHF", 1)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_56, [
                                                                    _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('order.discount')) + ": ", 1)
                                                                    ]),
                                                                    _cache[18] || (_cache[18] = _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, "0 CHF")
                                                                    ], -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_57, [
                                                                    _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, "TOTAL BRUT: ")
                                                                    ], -1)),
                                                                    _createElementVNode("span", null, [
                                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.total_price) + " CHF", 1)
                                                                    ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_58, [
                                                                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Méthode de paiements : ", -1)),
                                                                    (_ctx.methodePaiementSelected)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.methodePaiementSelected.libelle), 1))
                                                                        : _createCommentVNode("", true)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        _cache[26] || (_cache[26] = _createElementVNode("hr", { class: "dashed-line" }, null, -1)),
                                                        (_ctx.transformedData.orderSelf)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                                (_ctx.transformedData.orderSelf.feature)
                                                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_61, [
                                                                        _createElementVNode("strong", null, _toDisplayString(_ctx.transformedData.orderSelf.feature[0]), 1)
                                                                    ]))
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, "Trancher: " + _toDisplayString(_ctx.transformedData.orderSelf.intructionOrder?.isTrancher ? 'OUI' : 'NON'), 1)
                                                                ]),
                                                                _createElementVNode("h2", null, [
                                                                    _createElementVNode("strong", null, "Couverts: " + _toDisplayString(_ctx.transformedData.orderSelf.intructionOrder?.quantityCouverts || 0), 1)
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("button", {
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.previewPDF && _ctx.previewPDF(...args))),
                                    type: "button",
                                    class: "btn btn-primary"
                                }, "Imprimer maintenant")
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]));
}
